module.exports = __webpack_public_path__ + "img/gl.267163ff.svg";